import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-email-icon',
  templateUrl: './email-icon.component.svg',
  styleUrls: ['./email-icon.component.scss'],
})
export class EmailIconComponent {
  @Input() height = 18;
  @Input() width = 18;
  @Input() color = '#fff';
}
